// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9a06b2f6","455":"24187e2b","977":"1e13707d"}[chunkId] + ".chunk.js";
};